import React from 'react';
import { ArrowLeft } from 'lucide-react';
import HospitalIcon from '../../shared/icons/HospitalIcon';

/** First hex colour in a Tailwind gradient string like "from-[#9F8D70] to-[#8a7a61]" */
export const hospitalHex = (hospital) => (hospital.color.match(/#[0-9a-fA-F]{6}/) || ['#334155'])[0];

/**
 * Header for every hospital rotation page and tool screen: white, a thin band of the
 * hospital colour on top, the logo straight on white, the name in the display serif,
 * and the page subtitle in the hospital colour.
 */
const HospitalHeader = ({ hospital, subtitle, onBack }) => {
  const hex = hospitalHex(hospital);
  const back = (cls) => (
    <button onClick={() => { onBack(); }} className={`flex items-center gap-1.5 mb-4 hover:opacity-80 ${cls}`}>
      <ArrowLeft size={20} /><span className="text-[15px]">Back</span>
    </button>
  );

  return (
    <div className="bg-white dark:bg-gray-800">
      <div className="h-1.5" style={{ backgroundColor: hex }} aria-hidden="true" />
      <div className="px-6 pt-4 pb-5">
        {back('text-gray-500 dark:text-gray-400')}
        <div className="flex items-center gap-4">
          <HospitalIcon type={hospital.id} className="w-12 h-12 flex-shrink-0 text-gray-800 dark:text-white" />
          <div className="flex-1 min-w-0">
            <h1 className="font-display text-[22px] leading-tight font-bold text-gray-900 dark:text-white">{hospital.name}</h1>
            <p className="text-sm font-medium mt-1" style={{ color: hex }}>{subtitle}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HospitalHeader;
